export default __webpack_public_path__ + "static/media/remove.afa017eb.svg";